import mountQueries from './mountQueries'

const queries = { mountQueries }

export default queries
